import { connect } from 'react-redux';
import Sidebar from '../../components/Sidebar/Sidebar';

function mapStateToProps(state, ownProps) {
    return {
        routing: state.routing,
        user: state.user
    }
}

export default connect(
    mapStateToProps,
    { }
)(Sidebar);


// WEBPACK FOOTER //
// ./src/containers/Sidebar/SidebarContainer.js